export default [
    {
        path:'/contact',
        name:'contact',
        meta:{
            title:'CONTACT US'
        },
        component:() => import("../views/pages/contacts/contact.vue")
    }
]